import React from 'react'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { Table, Label, Icon, Popup } from 'semantic-ui-react'
import { Pagination, SortIcon } from '../components'
import { roles, courseTypesFormated } from '../../common/config'

const { Header, Body, Row, Cell, HeaderCell, Footer } = Table

const sortIcons = {
  ascending: <SortIcon ascending />,
  descending: <SortIcon descending />,
  sort: <SortIcon />,
}

const getPCOperatorsState = (result, role) => {
  if (result.courseType !== 'AUDIT') return '-'
  if (role === roles.PC_OPERATOR) {
    if (result.trafficRulesTestPoints === null) return <Label color="red" size="big">Nevyplněno</Label>
    return <Label color="green" size="big">{result.trafficRulesTestPoints} - Vyplněno</Label>
  }
  if (result.trafficRulesTestPoints === null) return <Label color="red" size="big">Čeká se</Label>
  return <Label color="green" size="big">{result.trafficRulesTestPoints}</Label>
}

const getPsychologistState = (result, role) => {
  if (result.courseType !== 'AUDIT') return '-'
  if (role === roles.PSYCHOLOGIST) {
    if (!result.psychologicalReportBy) return <Label color="red" size="big">Nevyplněno</Label>
    return <Label color="green" size="big">Vyplněno</Label>
  }
  if (!result.psychologicalReportBy) return <Label color="red" size="big">Čeká se</Label>
  return <Label color="green" size="big">{result.psychologicalReportBy.lastName}</Label>
}

const getInstructorsState = (result, role) => {
  let name
  if (role === roles.INSTRUCTOR) {
    name = result.closedByInstructorAt ? 'Uzavřeno' : 'Neuzavřeno'
  } else {
    if (!result.testedBy) return <Label color="red" size="big">Čeká se</Label>
    name = result.testedBy.lastName
  }
  const color = result.closedByInstructorAt ? 'green' : 'red'
  if (!result.testedBy) return <Label color="red" size="big">Čeká se</Label>
  return <Label color={color} size="big">{name}</Label>
}

const getSupervisorsState = (result) => {
  if (result.closedBySupervisorAt) return <Label color="green" size="big">Uzavřeno</Label>
  return <Label color="red" size="big">Neuzavřeno</Label>
}

const getRiskFactorState = (result) => {
  switch (result.result) {
    case 'PASSED': return <Label color="green" size="big">{result.safetyFactor} - Prospěl</Label>
    case 'FAILED': return <Label color="red" size="big">{result.safetyFactor} - Neprospěl</Label>
    default: return <Label color="grey" size="big">Nehodnoceno</Label>
  }
}

const getLink = (result, role) => {
  let label
  const auditFinished = result.psychologicalReport && typeof result.trafficRulesPoints !== 'undefined'
  switch (role) {
    case roles.FLEET_MANAGER:
      label = 'Zobrazit'
      break
    case roles.SUPERVISOR:
      if (
        result.closedByInstructorAt &&
        (result.courseType !== 'AUDIT' || auditFinished)
      ) label = 'Upravit'
      else label = 'Zobrazit'
      break
    case roles.ADMIN:
      // if (result.closedBySupervisorAt) label = 'Zobrazit' TODO: Fix in result form
      // else label = 'Upravit'
      label = 'Upravit'
      break
    case roles.INSTRUCTOR:
      if (result.closedByInstructorAt) label = 'Zobrazit'
      else label = 'Upravit'
      break
    default: label = 'Upravit'
  }
  if (label) return <Link to={`/results/${result._id}`}>{label}</Link>
  return null
}

const getColspan = (role) => {
  switch (role) {
    case roles.SUPERVISOR: return 9
    case roles.ADMIN: return 9
    case roles.INSTRUCTOR: return 6
    case roles.PSYCHOLOGIST: return 6
    case roles.PC_OPERATOR: return 6
    default: return 7
    // no default
  }
}

const getCompanyArchived = (result) => {
  if (result.archived) {
    return <Icon name="trash" color="red" size="large" />
  }
  else if (result.companyArchived || result.driverEmploymentFinished) {
    return <Icon name="remove user" color="red" size="large" />
  }
  else {
    return <Icon name="user" color="green" size="large" />
  }
}

const ResultsTable = ({
  results, meta, list, role, waitingForDownload, getCSV, csv, clearDownload,
}) => {
  const paging = list.$paging(meta.count)
  return (
    <Table className="results">
      <Header>
        <Row>
          <HeaderCell />
          <HeaderCell />
          <HeaderCell>{list.$heading('driverLastNameSort', 'Přijmení', sortIcons)}</HeaderCell>
          <HeaderCell>{list.$heading('driverFirstNameSort', 'Jméno', sortIcons)}</HeaderCell>
          {[roles.FLEET_MANAGER].indexOf(role) === -1 &&
            <HeaderCell>{list.$heading('companyNameSort', 'Dopravce', sortIcons)}</HeaderCell>
          }
          {/* <HeaderCell>{list.$heading('driverBirthdate', 'Datum narození', sortIcons)}</HeaderCell>*/}
          <HeaderCell>{list.$heading('testedAt', 'Datum', sortIcons)}</HeaderCell>
          {[roles.FLEET_MANAGER].indexOf(role) !== -1 &&
            <HeaderCell>{list.$heading('closedBySupervisorAt', 'Datum zveřejnění', sortIcons)}</HeaderCell>
          }
          <HeaderCell>{list.$heading('locationNameSort', 'Lokace', sortIcons)}</HeaderCell>
          <HeaderCell>{list.$heading('courseType', 'Akce', sortIcons)}</HeaderCell>
          {[roles.ADMIN, roles.SUPERVISOR].indexOf(role) !== -1 &&
            <HeaderCell>{list.$heading('trafficRulesTestPoints', 'Test', sortIcons)}</HeaderCell>
          }
          {[roles.ADMIN, roles.SUPERVISOR].indexOf(role) !== -1 &&
            <HeaderCell>Psycholog</HeaderCell>
          }
          {[roles.ADMIN, roles.SUPERVISOR].indexOf(role) !== -1 &&
            <HeaderCell>Instruktor</HeaderCell>
          }
          {[roles.ADMIN, roles.SUPERVISOR, roles.INSTRUCTOR].indexOf(role) !== -1 &&
            <HeaderCell>Stav uzavření</HeaderCell>
          }
          {[roles.PC_OPERATOR, roles.PSYCHOLOGIST].indexOf(role) !== -1 &&
            <HeaderCell>Stav vyplnění</HeaderCell>
          }
          {[roles.FLEET_MANAGER, roles.SUPERVISOR, roles.ADMIN].indexOf(role) !== -1 &&
            <HeaderCell>{list.$heading('safetyFactor', 'Faktor bezpečnosti', sortIcons)}</HeaderCell>
          }
          {[roles.FLEET_MANAGER, roles.SUPERVISOR, roles.ADMIN].indexOf(role) !== -1 &&
            <HeaderCell>Protokol</HeaderCell>
          }
          {[roles.FLEET_MANAGER, roles.SUPERVISOR, roles.ADMIN].indexOf(role) !== -1 &&
            <HeaderCell>Certifikát</HeaderCell>
          }
          {[roles.FLEET_MANAGER, roles.SUPERVISOR, roles.ADMIN].indexOf(role) === -1 &&
            <HeaderCell />
          }
        </Row>
      </Header>
      <Body>
        {results.map((r) => (
          <Row key={r._id} style={r.archived ? {background:'#ffeaea'} : {}}>
            <Cell className="cell-with-icon">{getCompanyArchived(r)}</Cell>
            <Cell>
            {r.driverEmploymentFinished &&
              <Popup
                trigger={<Icon name="ban" />}
                content="Pracovní poměr ukončen"
                position="right center"
              />
            }
            {r.archived &&
              <Label color="red" size="big">Koš</Label>
            }
            </Cell>
            <Cell>{r.driverLastName}</Cell>
            <Cell>{r.driverFirstName}</Cell>
            {[roles.FLEET_MANAGER].indexOf(role) === -1 &&
              <Cell>{r.companyName}</Cell>
            }
            {/* <Cell>{moment(r.driverBirthdate).format('D.M.YYYY')}</Cell> */}
            <Cell>
              {[roles.ADMIN, roles.SUPERVISOR, roles.INSTRUCTOR].indexOf(role) !== -1 &&
                moment(r.testedAt).format('D.M.YYYY HH:mm')
              }
              {[roles.ADMIN, roles.SUPERVISOR, roles.INSTRUCTOR].indexOf(role) === -1 &&
                moment(r.testedAt).format('D.M.YYYY')
              }
            </Cell>
            {[roles.FLEET_MANAGER].indexOf(role) !== -1 &&
              <Cell>{moment(r.closedBySupervisorAt).format('D.M.YYYY')}</Cell>
            }
            <Cell>{r.locationName}</Cell>
            <Cell>{r.courseType && courseTypesFormated[r.courseType].abbreviation}</Cell>
            {[roles.ADMIN, roles.SUPERVISOR, roles.PC_OPERATOR].indexOf(role) !== -1 &&
              <Cell>{getPCOperatorsState(r, role)}</Cell>
            }
            {[roles.ADMIN, roles.SUPERVISOR, roles.PSYCHOLOGIST].indexOf(role) !== -1 &&
              <Cell>{getPsychologistState(r, role)}</Cell>
            }
            {[roles.ADMIN, roles.SUPERVISOR, roles.INSTRUCTOR].indexOf(role) !== -1 &&
              <Cell>{getInstructorsState(r, role)}</Cell>
            }
            {[roles.ADMIN, roles.SUPERVISOR].indexOf(role) !== -1 &&
              <Cell>{getSupervisorsState(r)} </Cell>
            }
            {[roles.FLEET_MANAGER, roles.SUPERVISOR, roles.ADMIN].indexOf(role) !== -1 &&
              <Cell className="cell-no-wrap">
                {getRiskFactorState(r)}{' '}
                {r.recommendationForCompany && r.recommendationForCompany.length &&
                  <Popup
                    trigger={<Icon name="warning sign" color="orange" size="large" />}
                    content="Protokol obsahuje doporučení pro společnost."
                    position="left center"
                  />
                }
              </Cell>
            }
            {[roles.FLEET_MANAGER, roles.SUPERVISOR, roles.ADMIN].indexOf(role) !== -1 &&
              <Cell>
                {getLink(r, role)}
                {r.protocol ? ' / ' : ''}
                {r.protocol &&
                  <a href={`/${r.protocol}`} rel="noopener noreferrer" target="_blank">PDF</a>
                }
              </Cell>
            }
            {[roles.FLEET_MANAGER, roles.SUPERVISOR, roles.ADMIN].indexOf(role) !== -1 &&
              <Cell>
                {r.certificate &&
                  <a href={`/${r.certificate}`} rel="noopener noreferrer" target="_blank">Certifikát</a>
                }
              </Cell>
            }
            {[roles.FLEET_MANAGER, roles.SUPERVISOR, roles.ADMIN].indexOf(role) === -1 &&
              <Cell>
                {getLink(r, role)}
              </Cell>
            }
          </Row>
        ))}
      </Body>
      <Footer>
        <Row>
          <Cell colSpan={getColspan(role)}>
            {`
              Zobrazeno
              ${Math.min(((meta.currentPage - 1) * 100) + 1, meta.count)}
              -
              ${Math.min((meta.currentPage * 100) + 1, meta.count)} z ${meta.count}
            `}
            {(getCSV || csv) && <span>-&nbsp;</span>}
            {getCSV && !csv &&
              <span className="downloadCSV">
                {waitingForDownload
                  ? <Icon loading name="spinner" />
                  : <a onClick={getCSV}>Stáhnout CSV</a>
                }
              </span>
            }
            {getCSV && csv &&
              <a href={csv} rel="noopener noreferrer" target="_blank" onClick={clearDownload}>
                CSV připraveno, klikněte pro stažení
              </a>
            }
          </Cell>
          <Cell colSpan={6}><Pagination paging={paging} /></Cell>
        </Row>
      </Footer>
    </Table>
  )
}

ResultsTable.defaultProps = {
  getCSV: null,
  waitingForDownload: false,
  csv: '',
}

ResultsTable.propTypes = {
  results: React.PropTypes.object.isRequired,
  meta: React.PropTypes.object.isRequired,
  list: React.PropTypes.object.isRequired,
  role: React.PropTypes.string.isRequired,
  getCSV: React.PropTypes.any,
  waitingForDownload: React.PropTypes.bool,
  clearDownload: React.PropTypes.func.isRequired,
  csv: React.PropTypes.string,
}

export default ResultsTable



// WEBPACK FOOTER //
// ./src/browser/tables/Results.js